import { GROUP_CATEGORIES } from '@/lib/constants/groupCategories';
import type { GroupCategory } from '@/types/support';

interface GroupCategoryBadgesProps {
  categories: GroupCategory[];
  className?: string;
  showText?: boolean;
}

export function GroupCategoryBadges({ categories, className, showText = false }: GroupCategoryBadgesProps) {
  if (!categories?.length) return null;
  
  // Only show the first category icon
  const primaryCategory = categories[0];
  const icon = GROUP_CATEGORIES[primaryCategory];
  
  return (
    <span className={className}>
      {icon}{showText && ` ${primaryCategory}`}
    </span>
  );
}